import React from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';

const HelpCenter = ({modal, helpCenterlink}) => {
  const iconClassNames = classNames({
    'lnr lnr-question-circle' : true,
    'help_center__icon' : !!modal

  }); // END elClassNames

  const tooltipClassNames = classNames({
    'help_center__tooltip-modal': !!modal,
    'help_center__tooltip-topbar' : !modal

  }); // END elClassNames

  return (
    <div>
      <a  target="_blank" rel="noopener noreferrer" href={helpCenterlink}><span data-tip data-for='help_center' className={iconClassNames}></span></a>
      <ReactTooltip id='help_center' place='bottom' effect='solid'  type='light' className={tooltipClassNames}>
        <p>Ir al centro de ayuda</p>
      </ReactTooltip>
    </div>
  )

}// END HelpCenter

export default HelpCenter



// WEBPACK FOOTER //
// ./src/components/HelpCenter.js